import { ChartsModule as CustomChartsModule } from './charts/charts.module';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { AppRoutingModule } from './../app-routing.module';
import { ModalsModule } from './modals/modals.module';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialModule } from '../material.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagCloudModule } from 'angular-tag-cloud-module';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';

PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
	declarations: [MenuComponent, BreadcrumbsComponent, FooterComponent],
	imports: [
		ModalsModule,
		CommonModule,
		AppRoutingModule,
		MaterialModule,
		CustomChartsModule,
		TagCloudModule,
		PlotlyModule,
	],
	exports: [
		MenuComponent,
		FooterComponent,
		ModalsModule,
		BreadcrumbsComponent,
		CustomChartsModule,
	],
})
export class ComponentsModule {}
